import React, { Component } from "react";
import classNames from 'classnames';
import './index.less';

class PageContainer extends Component {
    static defaultProps = { pageClassType: "grid" }

    render() {
        let { pageClassType, children, ...others } = this.props;
        let classNameObj = {
            grid: "lowcode-list", //列表
            formgrid: 'lowcode-bill-card', //主子结构卡片
            treegrid: 'lowcode-tree-list', //树表
            treeform: 'lowcode-tree-card', //树卡
            transfercard: 'lowcode-transfer-card', //转单下游
            motherson: 'lowcode-motherson', //母子表
        };
        return <div {...others} className={classNames('low-code-root', classNameObj[pageClassType])}>
            {/* {this.props.children? React.Children.map(this.props.children, item=> item ? React.cloneElement(item): null): null} */}
            {children}
        </div>;
    }
}

export default PageContainer;
